module.exports = __webpack_public_path__ + "img/video_response_icon_blue.faf475fb.png";